<template>
  <section class="hero-branding bg-hero" id="home">
    <div class="container-fluid container-fluid--cp-150">
      <div class="hero-branding">
        <div class="hero-content w-100">
          <h2 class="h1 hero-content-title text-center">
            Die wunderbare Welt der Kunstbücher und ihre Möglichkeiten
          </h2>
          <h6 class="hero-content-subtitle mt-20 text-center">
            Ob Kunstliebhaber oder Händler – wir eröffnen Ihnen neue Wege für den Kauf und Verkauf von Kunstbüchern.
          </h6>

          <div class="slider-button mt-30 centered-play">
            <div class="play-btn" @click="openVideo" aria-label="Video abspielen" role="button" tabindex="0" @keyup.enter="openVideo">
              <svg fill="#083cc8" height="100%" width="100%" viewBox="0 0 512 512" aria-hidden="true">
                <g><g><path d="M256,0C114.608,0,0,114.608,0,256s114.608,256,256,256s256-114.608,256-256S397.392,0,256,0z M256,496
                  C123.664,496,16,388.336,16,256S123.664,16,256,16s240,107.664,240,240S388.336,496,256,496z"/></g></g>
                <g><g><path d="M176.416,129.792v252.416L395.024,256L176.416,129.792z M192.416,157.504L363.024,256l-170.608,98.496V157.504z"/></g></g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="isVideoOpen"
        class="video-overlay"
        role="dialog"
        aria-modal="true"
        aria-label="Video-Overlay"
        @click="onOverlayClick"
      >
        <div class="video-wrapper" @click.stop>
          <button class="close-btn" @click="closeVideo" aria-label="Schließen">×</button>

          <video
            ref="heroVideo"
            :src="videoSrc"
            controls
            autoplay
            playsinline
            class="video-el"
          ></video>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import ScrollTo from './mixins/scrollTo.js'
import videoSrc from '@/assets/img/agency/mhp.mp4'

export default {
  mixins: [ScrollTo],
  data () {
    return {
      isVideoOpen: false,
      videoSrc
    }
  },
  methods: {
    openVideo () {
      this.isVideoOpen = true
      this.$nextTick(() => {
        const v = this.$refs.heroVideo
        if (v) {
          const p = v.play && v.play()
          if (p && typeof p.catch === 'function') {
            p.catch(() => {})
          }
        }
        document.body.classList.add('no-scroll')
      })
    },
    closeVideo () {
      const v = this.$refs.heroVideo
      if (v) {
        v.pause()
        v.currentTime = 0
      }
      this.isVideoOpen = false
      document.body.classList.remove('no-scroll')
    },
    onOverlayClick (e) {
      if (e.target === e.currentTarget) this.closeVideo()
    },
    onKeydown (e) {
      if (e.key === 'Escape') this.closeVideo()
    }
  },
  mounted () {
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeydown)
  }
}
</script>

<style lang="scss">
@use '../assets/scss/variabls.scss' as vars;
@use '../assets/scss/elements/hero-branding.scss';

.centered-play {
  display: flex;
  justify-content: center;
}

.play-btn {
  border-radius: 100%;
  height: 5rem;
  width: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media #{vars.$tablet-up} {
  .bg-hero {
    background-size: cover;
    background: url('../assets/img/hero/branding/Bibliophile.svg');
    background-size: 30%;
    background-repeat: no-repeat;
    background-position-x: 90%;
    background-position-y: 90%;
  }

  .play-btn {
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
  }

  .play-btn:hover {
    transform: rotate(35deg);
  }
}

.no-scroll { overflow: hidden; }

.fade-enter-active, .fade-leave-active { transition: opacity .18s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

.video-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9990;
  padding: 1rem;
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-el {
  width: 100%;
  max-height: 80vh;
  border-radius: .5rem;
  outline: none;
  background: #000;
}

.close-btn {
  position: absolute;
  top: .25rem;
  right: .5rem;
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  border-radius: 50%;
  background: rgba(255,255,255,.9);
  font-size: 1.5rem;
  line-height: 2.25rem;
  text-align: center;
  cursor: pointer;
  z-index: 1;
}

.close-btn:hover {
  transform: scale(1.05);
}

@media (max-width: 600px) {
  .close-btn {
    top: .125rem;
    right: .25rem;
  }
}
</style>
